export default __webpack_public_path__ + "static/media/Audio-Number-9.51134295.mp3";